import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
const shortTestimonials = [{
  quote: 'I booked my first full-planning client at $3,500 — double what I was going to charge — because I finally had real packages and a real process to show her.',
  author: 'Sarah M.',
  role: 'Wedding Planner',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/0d0ee85d-95d7-4146-828f-f2a3117a6dd2.jpg'
}, {
  quote: 'The minute-by-minute timeline saved my last wedding. A vendor showed up 40 minutes late and nobody — not even the bride — ever knew there was a problem.',
  author: 'Jasmine R.',
  role: 'Planner & Stylist',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/52a58441-364e-4526-9dad-6c0b44ac98a6.jpg'
}, {
  quote: 'Vendors treat me completely differently now. I walk into production meetings with agendas and checklists, and they follow my lead instead of walking all over me.',
  author: 'Emily T.',
  role: 'Event & Wedding Planner',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/dd44de40-f002-4df5-89ae-eed50c6fbe16.jpg'
}];
const moreTestimonials = [{
  quote: 'Volume 5 alone is worth ten times the price. I ran my first solo wedding with the minute-by-minute timeline and the mother of the bride asked for my card.',
  author: 'Wedding Planner',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/62b31cb0-0b93-40f5-8be9-be131d53ced8.jpg'
}, {
  quote: 'I used the Discovery Call Framework on a Tuesday. By Friday I had signed my highest-paying client ever.',
  author: 'Planner, 2nd year',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/406070fe-5ea6-47c1-8bf4-d4d224bfde91.jpg'
}, {
  quote: 'I stopped feeling like a fraud. I open the volume, follow the system, and clients keep telling me how “organized” I am. If only they knew it all came from one PDF.',
  author: 'New Wedding Planner',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/ce9499ec-56ad-4da2-bd0f-8e21e718ae17.jpg'
}];
export function App() {
  return <div className="min-h-screen w-full bg-ivory text-ink font-sans selection:bg-gold selection:text-ink" data-id="element-0" data-mp="18e18lhastiig">
      <MetaPixel data-id="element-1" data-mp="1d4zucwek38t3" />
      <main data-id="element-2" data-mp="1d5jac7knbn4h">
        <Hero data-id="element-3" data-mp="1d59hmc87v1v3" />
        <SocialProofBar data-id="element-4" data-mp="1d5srr6rmklyk" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-5" data-mp="yfljfjvc0jbl" />
        <PainGrid data-id="element-6" data-mp="ydii43oqb3rk" />
        <BigIdea data-id="element-7" data-mp="13eoc04u4kx2o" />
        <ProductReveal data-id="element-8" data-mp="13e55dk9xdv3y" />
        <Tomes data-id="element-9" data-mp="13fpzj8sbvc1a" />
        <Bonuses data-id="element-10" data-mp="13f7tjkfv5jg6" />
        <Urgency data-id="element-11" data-mp="13clpvvw3fo38" />
        <Pricing data-id="element-12" data-mp="1r497tobdnotd" />
        <Transformation data-id="element-13" data-mp="1r3r5qb21agdj" />
        <Testimonials testimonials={moreTestimonials} title="More planners, more weddings run right" background="ivory" data-id="element-14" data-mp="1r5kd5skh14ml" />
        <Guarantee data-id="element-15" data-mp="1i3ukkjeurzn8" />
        <Faq data-id="element-16" data-mp="1i4ccj3uhfrpc" />
        <CostOfInaction data-id="element-17" data-mp="1i2sx1fgnhkom" />
        <Close data-id="element-18" data-mp="1i3azittwov4z" />
      </main>
      <Footer data-id="element-19" data-mp="1m565ibms7wp3" />
    </div>;
}